import AchievementSlider from './front-page/AchievementSlider';

(() => {
  const init = () => {
    AchievementSlider();
  };

  window.addEventListener('DOMContentLoaded', () => {
    init();
  });
})();
